/*
 * @LastEditors: zhanglinju
 */

export const mobileBox = () => import(/* webpackChunkName: "textproject" */ './mobileBox');

export const mobileContent = () => import(/* webpackChunkName: "textproject" */ './mobileContent.vue');
// export const content = () => import(/* webpackChunkName: "textproject" */ './content.vue');
export default [
    {
        path: '/mobileModules',
        name: 'mobileModules',
        component: mobileBox,
    },
    {
        path: '/mobileBoxContent',
        name: 'mobileBoxContent',
        component: mobileContent,

    },
    // {
    //     path: '/mobileContent',
    //     name: 'mobileContent',
    //     component: content,

    // },
];
